const ProcessTimeline = () => {
  const steps = [
    {
      icon: 'ri-file-edit-line',
      title: '提交申请',
      description: '填写申请表单并上传证明材料'
    },
    {
      icon: 'ri-search-eye-line',
      title: '审核',
      description: '工作人员核实信息，3-5个工作日'
    },
    {
      icon: 'ri-notification-line',
      title: '通知',
      description: '审核通过后短信/电话通知'
    },
    {
      icon: 'ri-truck-line',
      title: '配送',
      description: '志愿者上门配送爱心物资'
    }
  ];

  return (
    <div className="relative">
      {/* Desktop Timeline */}
      <div className="hidden md:flex items-start justify-between">
        {steps.map((step, index) => (
          <div key={index} className="flex flex-col items-center flex-1 relative">
            {/* Icon Circle */}
            <div className="w-20 h-20 bg-gradient-to-br from-[#2A7A62] to-[#3A9A82] rounded-full flex items-center justify-center shadow-lg mb-6 relative z-10">
              <i className={`${step.icon} text-white text-3xl`}></i>
            </div>
            
            {/* Content */}
            <div className="text-center">
              <h3 className="text-xl font-bold text-[#1E1E1E] mb-2">{step.title}</h3>
              <p className="text-sm text-[#6C6C6C] max-w-[200px]">{step.description}</p>
            </div>

            {/* Connecting Line */}
            {index < steps.length - 1 && (
              <div className="absolute top-10 left-[60%] w-full h-1 bg-gradient-to-r from-[#2A7A62] to-[#3A9A82]"></div>
            )}
          </div>
        ))}
      </div>

      {/* Mobile Timeline */}
      <div className="md:hidden space-y-6">
        {steps.map((step, index) => (
          <div key={index} className="flex items-start gap-4">
            {/* Icon Circle */}
            <div className="w-16 h-16 bg-gradient-to-br from-[#2A7A62] to-[#3A9A82] rounded-full flex items-center justify-center shadow-lg flex-shrink-0">
              <i className={`${step.icon} text-white text-2xl`}></i>
            </div>
            
            {/* Content */}
            <div className="flex-1 pt-2">
              <h3 className="text-lg font-bold text-[#1E1E1E] mb-1">{step.title}</h3>
              <p className="text-sm text-[#6C6C6C]">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProcessTimeline;